import React from "react";
import ReactDom from "react-dom";
import AIBot from "./AIBot.jsx";

let observer = null;
let hasRendered = false;

export function initAIBot() {
  if (hasRendered) {
    return;
  }

  // Check if React is available
  if (typeof React === "undefined" || typeof ReactDom === "undefined") {
    setTimeout(() => {
      if (typeof React !== "undefined" && typeof ReactDom !== "undefined") {
        initAIBot();
      }
    }, 100);
    return;
  }

  // Try to find mount point immediately
  const mountPoint = document.querySelector(".js-ai-bot-mount");
  
  if (mountPoint) {
    renderAIBot(mountPoint);
    return;
  }

  // Set up observer to watch for mount point
  observer = new MutationObserver(() => {
    const mountPoint = document.querySelector(".js-ai-bot-mount");
    if (mountPoint && !hasRendered) {
      renderAIBot(mountPoint);
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Fallback retries
  setTimeout(() => {
    const mountPoint = document.querySelector(".js-ai-bot-mount");
    if (mountPoint && !hasRendered) {
      renderAIBot(mountPoint);
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }
  }, 500);

  setTimeout(() => {
    const mountPoint = document.querySelector(".js-ai-bot-mount");
    if (mountPoint && !hasRendered) {
      renderAIBot(mountPoint);
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }
  }, 2000);
}

function renderAIBot(mountPoint) {
  if (!mountPoint || mountPoint.querySelector("df-messenger")) {
    hasRendered = true;
    return;
  }

  if (typeof React === "undefined" || typeof ReactDom === "undefined") {
    console.error("[AIBot] ERROR: React or ReactDom is not available");
    return;
  }

  // Extract data attributes (only pass if they exist; component uses DEFAULT_CONFIG fallbacks)
  const props = {};
  const projectId = mountPoint.getAttribute("data-project-id");
  const agentId = mountPoint.getAttribute("data-agent-id");
  const languageCode = mountPoint.getAttribute("data-language-code");
  const maxQueryLength = mountPoint.getAttribute("data-max-query-length");
  const chatTitle = mountPoint.getAttribute("data-chat-title");
  const chatIcon = mountPoint.getAttribute("data-chat-icon");
  const disclaimerMessage = mountPoint.getAttribute("data-disclaimer-message");
  const welcomeGreeting = mountPoint.getAttribute("data-welcome-greeting");
  const oauthClientId = mountPoint.getAttribute("oauth-client-id");
  const accessTokenName = mountPoint.getAttribute("access-token-name");

  if (projectId != null && projectId !== "") props.projectId = projectId;
  if (agentId != null && agentId !== "") props.agentId = agentId;
  if (languageCode != null && languageCode !== "") props.languageCode = languageCode;
  if (maxQueryLength != null && maxQueryLength !== "") props.maxQueryLength = maxQueryLength;
  if (chatTitle != null && chatTitle !== "") props.chatTitle = chatTitle;
  if (chatIcon != null && chatIcon !== "") props.chatIcon = chatIcon;
  if (disclaimerMessage != null && disclaimerMessage !== "") props.disclaimerMessage = disclaimerMessage;
  if (welcomeGreeting != null && welcomeGreeting !== "") props.welcomeGreeting = welcomeGreeting;
  if (oauthClientId != null && oauthClientId !== "") props.oauthClientId = oauthClientId;
  if (accessTokenName != null && accessTokenName !== "") props.accessTokenName = accessTokenName;

  props.isGated = mountPoint.classList.contains("gated");

  try {
    ReactDom.render(<AIBot {...props} />, mountPoint);
    hasRendered = true;
  } catch (error) {
    console.error("[AIBot] ERROR: Failed to render component:", error);
  }
}

